import { render, staticRenderFns } from "./BulkModal.vue?vue&type=template&id=2df04ac9&"
import script from "./BulkModal.vue?vue&type=script&lang=js&"
export * from "./BulkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports